import { UseQueryResult } from "@tanstack/react-query"
import {
  ITOCertificate,
  LearningCertificate,
  MasterclassUserCredential,
} from "api/resources/profile/types"
import { APIResponse } from "api/types"
import NoCertificates from "assets/Fallback/no-certificates.svg"
import clsx from "clsx"
import Fallback from "components/Fallback"
import FullPageLoading from "components/FullPageLoading"
import ShareSheet from "components/ShareSheet"
import React, { useState } from "react"

import MasterclassCard from "../Cards/MasterclassCard"
import styles from "./Masterclasses.module.css"

type Props = {
  masterclassCertificates: UseQueryResult<
    APIResponse<
      LearningCertificate[] | ITOCertificate[] | MasterclassUserCredential[]
    >
  >
}

const Masterclasses = (props: Props) => {
  const [certificateUrl, setCertificateUrl] = useState<string>("")

  if (props.masterclassCertificates.isError) {
    return (
      <Fallback
        data={{
          image: NoCertificates,
          title: "Something went wrong!",
          description: "Please try again later.",
        }}
        className="fixed left-1/2 top-1/2 w-full -translate-x-1/2 -translate-y-1/2 px-2 text-center sm:w-fit sm:px-0"
        hasError={true}
      />
    )
  }

  if (
    !props.masterclassCertificates.data ||
    props.masterclassCertificates.isLoading
  ) {
    return <FullPageLoading />
  }

  if (props.masterclassCertificates.data.length === 0) {
    return (
      <Fallback
        data={{
          image: NoCertificates,
          title: "Looks like you don't have any certificates yet!",
          description: "Attend masterclasses to earn certificates.",
        }}
        className="absolute left-1/2 top-[60%] w-full -translate-x-1/2 -translate-y-1/2 px-2 text-center sm:w-fit sm:px-0"
        hasError={false}
      />
    )
  }
  return (
    <div
      className={clsx(
        "mb-4 grid gap-1 sm:gap-x-3 sm:gap-y-2 md:gap-x-2",
        styles.masterClassGridContainer
      )}
    >
      {props.masterclassCertificates.data.map((item, index) => (
        <MasterclassCard
          setCertificateUrl={url => setCertificateUrl(url)}
          key={index}
          data={item}
        />
      ))}
      <ShareSheet
        data={{
          url: certificateUrl,
          text: `Checkout my certificate on Suraasa: ${certificateUrl}`,
        }}
        open={!!certificateUrl}
        handleClose={() => {
          setCertificateUrl("")
        }}
      />
    </div>
  )
}

export default Masterclasses
